// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1gDoE","footer":"Form_footer__2Cj-M"};